import React, { useState, useEffect } from "react";
import "./Contact.css";

function Contact() {
  const [showMsg, setShowMsg] = useState(false);
  const [userName, setUserName] = useState("");
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );

  // Load Font Awesome icons dynamically & Scroll to top
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Injected Font Awesome link to make sure icons render properly
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css";
    document.head.appendChild(link);

    return () => {
      // Cleanup link on component unmount
      if (document.head.contains(link)) {
        document.head.removeChild(link);
      }
    };
  }, []);

  // Responsive resize handler
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSubmit = (e) => {
    const formElement = e.target;
    const formData = new FormData(formElement);

    setUserName(formData.get("name"));
    setShowMsg(true);

    setTimeout(() => {
      setShowMsg(false);
      formElement.reset();
    }, 5000);
  };

  const isMobile = windowWidth <= 768;

  // Google Maps Direct Location Link for Zero Pix Creative
  const mapUrl = "https://maps.google.com/?q=Zero+Pix+Creative+Rajaji+Rd+opposite+to+kiruba+hospital+Kumarasamipatti+Salem+Tamil+Nadu+636007";

  return (
    <div className="contact-wrapper">
      <div className="contact-container">
        
        {/* LEFT SECTION */}
        <div className="hero-section">
          <div className="breadcrumb">
            <span className="dot"></span> READY TO START?
          </div>

          <h1 className="hero-title">
            LET'S BUILD <br />
            <span className="outline-text">THE FUTURE.</span>
          </h1>

          <p className="hero-desc">
            We help ambitious brands and architects stand out in the digital era.
            Drop us a message today.
          </p>

          {/* INFO TILES */}
          <div className="info-tiles">
            
            {/* EMAIL TILE */}
            <div className="tile" style={{ display: "flex", alignItems: "flex-start" }}>
              <span 
                className="tile-icon icon-circle-frame" 
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "44px",
                  height: "44px",
                  borderRadius: "50%",
                  border: "1.5px solid #000000",
                  marginRight: "15px",
                  flexShrink: 0
                }}
              >
                <i className="fas fa-envelope" style={{ fontSize: "16px", margin: 0 }}></i>
              </span>
              <div className="tile-content">
                <small>EMAIL</small>
                <p>design.zeropixcreative@gmail.com</p>
              </div>
            </div>

            {/* CALL TILE */}
            <div className="tile" style={{ display: "flex", alignItems: "flex-start" }}>
              <span 
                className="tile-icon icon-circle-frame" 
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "44px",
                  height: "44px",
                  borderRadius: "50%",
                  border: "1.5px solid #000000",
                  marginRight: "15px",
                  flexShrink: 0
                }}
              >
                <i className="fas fa-phone" style={{ fontSize: "16px", margin: 0 }}></i>
              </span>
              <div className="tile-content">
                <small>CALL</small>
                <p>+91 9487177305</p>
              </div>
            </div>

            {/* ✅ Address wrapped in a link tag with Circle Icon Container */}
            <a 
              href={mapUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="tile address-tile-link"
              style={{ textDecoration: "none", color: "inherit", display: "flex", alignItems: "flex-start" }}
            >
              {/* Perfect Circle Wrapper style around the icon */}
              <span 
                className="tile-icon icon-circle-frame" 
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "44px",
                  height: "44px",
                  borderRadius: "50%",
                  border: "1.5px solid #000000",
                  marginRight: "15px",
                  flexShrink: 0
                }}
              >
                <i className="fas fa-location-dot" style={{ fontSize: "16px", margin: 0 }}></i>
              </span>
              <div className="tile-content">
                <small style={{ display: "block", color: "#888", fontWeight: "600", fontSize: "11px", letterSpacing: "0.5px" }}>ADDRESS</small>
                <strong style={{ display: "block", marginTop: "4px", fontSize: "15px", fontWeight: "700", color: "#000" }}>
                  Zero Pix Creative
                </strong>
                <p style={{ marginTop: "2px", fontSize: "14px", color: "#333", lineHeight: "1.4" }}>
                  Rajaji Rd, opposite to kiruba hospital, Kumarasamipatti, Salem, Tamil Nadu 636007
                </p>
              </div>
            </a>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="form-card">
          <form
            action="https://formsubmit.co/design.zeropixcreative@gmail.com"
            method="POST"
            target="hidden_iframe"
            onSubmit={handleSubmit}
          >
            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_template" value="table" />

            <div className="form-group">
              <label>01. FULL NAME</label>
              <input type="text" name="name" placeholder="John Doe *" required />
            </div>

            <div className="form-group">
              <label>02. EMAIL ADDRESS</label>
              <input
                type="email"
                name="email"
                placeholder="john@example.com *"
                required
              />
            </div>

            <div className="form-group">
              <label>03. MESSAGE</label>
              <textarea
                name="message"
                placeholder="Project details..."
                rows={isMobile ? 3 : 5}
                required
              />
            </div>

            <button type="submit" className="prime-btn">
              SEND MESSAGE <span className="arrow">→</span>
            </button>
          </form>

          <iframe name="hidden_iframe" style={{ display: "none" }}></iframe>
        </div>
      </div>

      {/* TOAST */}
      {showMsg && (
        <div className="floating-toast">
          <div className="bot-pulse"></div>

          <div className="toast-text">
            <span className="toast-tag">SUCCESSFUL</span>
            <p className="toast-msg">
              Hi {userName}, Message Transmitted!
            </p>
          </div>

          <div className="toast-bar"></div>
        </div>
      )}
    </div>
  );
}

export default Contact;